import React, { useCallback, useMemo } from "react";
import { connect } from "react-redux";
import FormField from '../../../../../dynamicFormBuilder/FormField';
import { PrimaryLayout } from '../Layout';

function PrimaryTab(props) {
    var currentUser = props.oidc?.user;
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;

    const finalLayout = useMemo(() => PrimaryLayout, []);

    const handlePrimaryFormLoad = useCallback(() => {
        // No lookups for this minimal form (Record # + Serial Number).
    }, []);

    return (
        <div>
            <FormField
                currrentUser={currentUser}
                layoutId='D4E5F6A7-B8C9-0123-EFAB-456789ABCDEF'
                layoutName='WMSerialNumberCodesPrimaryForm'
                defaultFormSchema={finalLayout}
                formFields={props.formFields}
                setformFields={props.setformFields}
                handleFieldValueChange={props.handleFieldChange}
                DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                formRefs={props.formRefs}
                onFormLoad={handlePrimaryFormLoad}
            />
        </div>
    );
}

function mapStateToProps(state) {
    return {
        oidc: state.oidc
    };
}

export default connect(mapStateToProps)(PrimaryTab);
